import { Component, Input, OnInit } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { TextareaField } from "../models/field-textarea";

@Component({
  selector: "sd-form-field-textarea",
  templateUrl: "./sd-form-field-textarea.component.html",
  styleUrls: ["./sd-form-field-textarea.component.css"],
})
export class SdFormFieldTextareaComponent implements OnInit {
  @Input() formField: TextareaField;
  @Input() control: UntypedFormControl;
  @Input() formGroup: UntypedFormGroup;
  constructor() {}

  ngOnInit() {}
}
